<template>
  <div v-if="banners.length" class="mb-3 owl-credits" :class="{'owl-credits__joker': unit === 'joker'}">
    <div class="owl-credits__wrapper">
      <div class="owl-credits__box">
        <div v-if="user" class="card-points__box-points">
          <p v-if="unit==='coin'" class="card-points__points">
            {{ user.coins + user.free_coins }}
            <i class="demo-icon icon-n-lova-coins"></i>
          </p>
          <p v-if="unit==='joker'" class="card-points__points">
            {{ user.jokers + user.free_jokers }}
            <i class="demo-icon icon-n-joker-coins"></i>
          </p>
        </div>
      </div>
    </div>
    <div v-if="banners.length && user">
      <OwlCarousel :items="1" :mouseDrag="true" :touchDrag="true" :pullDrag="false" :loop="true" :freeDrag="false" :nav="false" :responsive="responsive">
        <div class="owl-credits__box-inner" v-for="banner in banners">
          <div class="owl-credits__img"><img alt="" :src="banner.img" /></div>
          <div class="owl-credits__title title title--white mb-2"> {{ banner.title }}</div>
          <div class="owl-credits__desc desc desc--white mb-4"> {{ banner.content }}</div>
        </div>
      </OwlCarousel>
    </div>
  </div>
</template>

<script>

import OwlCarousel from '../../modules/OwlCarousel';
import { mapGetters } from 'vuex';

export default {
  name: 'BannerComponent',
  components: { OwlCarousel },
  props: {
    unit: {
      type: String,
      required: true,
      validator: function (value) {
        return ['coin', 'joker'].indexOf(value) !== -1;
      }
    },
  },
  data() {
    return {
      banners: [],
      gUnit: {
        coin: window.globals.customer_shop_package.unit_coin,
        joker: window.globals.customer_shop_package.unit_joker,
      },
      responsive: {},
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    avatars: function () {
      return this.$store.getters['homeProfiles/getRandomAvatars'];
    },
  },
  watch: {},
  methods: {
    fetchBanners: function () {
      // disable banner show, task: #863gzgdg5
      // axios.get(zRoute('ajax.payment.banner'))
      //   .then((response) => {
      //     this.banners = response.data.data;
      //   });
    },
  },
  mounted() {
    this.$store.dispatch('homeProfiles/load');
    this.fetchBanners();
  }
};
</script>
